export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сан"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Аты"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Әрекеттер"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Коллектор туралы ақпаратты өңдеу"])}
}